import { Link } from 'react-router-dom';
export default function NotFound() {
  return (
    <div className="container notfound">
      <h1>Página no encontrada</h1>
      <p>El enlace puede haber cambiado o la propiedad ya no está disponible.</p>
      <Link className="btn btn-primary" to="/">Volver al inicio</Link>
    </div>
  );
}
